import React, { Component } from "react";
import { Space, Button, Popconfirm, } from "antd";

import "./ColumnAction.less";

export default class ColumnAction extends Component {

  getActionComp = (item) => {
    if (React.isValidElement(item)) {
      return item;
    }

    const { type = "", visible } = item;
    if (false === visible) {
      return null;
    }

    if ("view" === type) {
      return (
        <Button
          type="link"
          size="small"
          onClick={item.onClick}
        >
          {item.title || "查看"}
        </Button>
      );
    }

    if ("update" === type) {
      return (
        <Button
          type="link"
          size="small"
          onClick={item.onClick}
        >
          {item.title || "修改"}
        </Button>
      );
    }

    if ("delete" === type) {
      return (
        <Popconfirm
          disabled={false}
          onConfirm={item.onClick}
          title={"是否" + (item.title || "删除")}
        >
          <Button
            danger
            type="link"
            size="small"
          >
            {item.title || "删除"}
          </Button>
        </Popconfirm>
      );
    }

    if (type) {
      return (
        <Button
          type="link"
          size="small"
          onClick={item.onClick}
        >
          {item.title}
        </Button>
      )
    }

    return null;
  };

  render() {
    const { actions = [] } = this.props;
    return (
      <div className="nano-table-list-column-action">
        <Space size="middle">
          {/* 限制10个按钮数量 */}
          {actions.length > 0 && this.getActionComp(actions[0])}
          {actions.length > 1 && this.getActionComp(actions[1])}
          {actions.length > 2 && this.getActionComp(actions[2])}
          {actions.length > 3 && this.getActionComp(actions[3])}
          {actions.length > 4 && this.getActionComp(actions[4])}
          {actions.length > 5 && this.getActionComp(actions[5])}
          {actions.length > 6 && this.getActionComp(actions[6])}
          {actions.length > 7 && this.getActionComp(actions[7])}
          {actions.length > 8 && this.getActionComp(actions[8])}
          {actions.length > 9 && this.getActionComp(actions[9])}
        </Space>
      </div>
    );
  };

};
